import { Rankine } from "@/libs/units/temperature";
import type { SolutionGasRsoCalculator } from "../../d";

export const solutionGasRsoCalculator: SolutionGasRsoCalculator = params => {
  const {
    oilSpecificGravity,
    oilAPI,
    gasOilRatio,
    gasSpecificGravity, // Ensure this is properly passed in from params
    inSituPressurePSIA, // Ensure this is properly passed in from params
    temperatureF // Ensure this is properly passed in from params
  } = params;

  // Convert In-Situ Temperature from °F to °R
  const inSituTemperatureR = Rankine.toThisUnit(temperatureF);

  // Updated Molecular Weight Estimate (M_o) Equation:
  // static/Fluid.Schutff.Kevin.Edition_with.Lasater.changes.xlsx
  // M_o = 558.16 + 1.1025*API - 0.50033*(API^2) + (8.32591e-3)*(API^3) - (3.8688e-5)*(API^4)
  const M_o =
    558.16 +
    1.1025 * oilAPI -
    0.50033 * oilAPI ** 2 +
    8.32591e-3 * oilAPI ** 3 -
    3.8688e-5 * oilAPI ** 4;

  // Updated Mol Fraction of Gas (y_g):
  // y_g = 0.08729793 + 0.37912718 * ln(((inSituPressurePSIA * gasSpecificGravity) / inSituTemperatureR) + 0.767066)
  const y_g =
    0.08729793 +
    0.37912718 *
      Math.log(
        (inSituPressurePSIA * gasSpecificGravity) / inSituTemperatureR +
          0.767066
      );

  // Now recalculate Rso using the updated values:
  // Rso at reservoir = ((379.3 * 350 * oilSpecificGravity) / M_o) * (y_g / (1 - y_g))
  const solutionGasRsoAtReservoir =
    ((379.3 * 350 * oilSpecificGravity) / M_o) * (y_g / (1 - y_g));

  // Limit the Rso at In-Situ conditions to not exceed the gasOilRatio
  const solutionGasRsoInSitu =
    solutionGasRsoAtReservoir > gasOilRatio
      ? gasOilRatio
      : solutionGasRsoAtReservoir;

  return {
    molecularWeightEstimate_M_o: M_o,
    molFractionOfGas_y_g: y_g,
    solutionGasRsoAtReservoir:
      solutionGasRsoAtReservoir > gasOilRatio
        ? gasOilRatio
        : solutionGasRsoAtReservoir,
    solutionGasRsoInSitu:
      solutionGasRsoInSitu > gasOilRatio ? gasOilRatio : solutionGasRsoInSitu
  };
};
